import { Store } from 'src/store/index';

const isDesignLoaded = (store: Store) => store.design.isLoaded;

export default isDesignLoaded;
